export const RELATIONSHIP_CATEGORIES = [
  {
    key: 'CLOSE_FAMILY',
    label: 'Close Family',
    eventKinds: 'Birthdays, anniversaries, weddings, family functions, festivals, vacations, personal events',
    group: 'family',
  },
  {
    key: 'FAMILY',
    label: 'Family',
    eventKinds: 'Birthdays, anniversaries, weddings, family functions, festivals, vacations',
    group: 'family',
  },
  {
    key: 'CLOSE_FRIEND',
    label: 'Close Friend',
    eventKinds: 'Birthdays, parties, weddings, trips, celebrations, personal events',
    group: 'friend',
  },
  {
    key: 'FRIEND',
    label: 'Friend',
    eventKinds: 'Birthdays, parties, weddings, celebrations, social events',
    group: 'friend',
  },
  {
    key: 'ACQUAINTANCE',
    label: 'Acquaintance',
    eventKinds: 'Public events, meetups, networking, community events',
    group: 'simple',
  },
  {
    key: 'OFFICE_COLLEAGUE',
    label: 'Office Colleague',
    eventKinds: 'Meetings, office events, team outings, training, conferences, work anniversaries',
    group: 'office',
  },
  {
    key: 'FORMER_COLLEAGUE',
    label: 'Former Colleague',
    eventKinds: 'Reunions, networking, conferences, professional events',
    group: 'former',
  },
  {
    key: 'PROFESSIONAL_CONTACT',
    label: 'Professional Contact',
    eventKinds: 'Meetings, conferences, workshops, networking, business events',
    group: 'professional',
  },
  {
    key: 'CLIENT',
    label: 'Client',
    eventKinds: 'Meetings, appointments, project milestones, conferences, business events',
    group: 'client',
  },
  {
    key: 'NEIGHBOR',
    label: 'Neighbor',
    eventKinds: 'Society events, festivals, community events, local meetups',
    group: 'neighbor',
  },
  {
    key: 'CLASSMATE',
    label: 'Classmate',
    eventKinds: 'Reunions, birthdays, college/school events, trips, celebrations',
    group: 'classmate',
  },
  {
    key: 'COMMUNITY',
    label: 'Community',
    eventKinds: 'Community events, festivals, sports, workshops, cultural/religious events',
    group: 'community',
  },
  {
    key: 'OTHER',
    label: 'Other',
    eventKinds: 'Any event explicitly shared by the user',
    group: 'simple',
  },
];

const FAMILY_RELATIONS = [
  { key: 'wife', label: 'Wife', extras: ['anniversary'] },
  { key: 'husband', label: 'Husband', extras: ['anniversary'] },
  { key: 'partner', label: 'Partner', extras: ['anniversary'] },
  { key: 'mother', label: 'Mother', extras: [] },
  { key: 'father', label: 'Father', extras: [] },
  { key: 'son', label: 'Son', extras: [] },
  { key: 'daughter', label: 'Daughter', extras: [] },
  { key: 'brother', label: 'Brother', extras: [] },
  { key: 'sister', label: 'Sister', extras: [] },
  { key: 'grandmother', label: 'Grandmother', extras: [] },
  { key: 'grandfather', label: 'Grandfather', extras: [] },
  { key: 'grandson', label: 'Grandson', extras: [] },
  { key: 'granddaughter', label: 'Granddaughter', extras: [] },
  { key: 'mother_in_law', label: 'Mother-in-law', extras: [] },
  { key: 'father_in_law', label: 'Father-in-law', extras: [] },
  { key: 'brother_in_law', label: 'Brother-in-law', extras: [] },
  { key: 'sister_in_law', label: 'Sister-in-law', extras: [] },
  { key: 'son_in_law', label: 'Son-in-law', extras: [] },
  { key: 'daughter_in_law', label: 'Daughter-in-law', extras: [] },
  { key: 'uncle', label: 'Uncle', extras: ['familySide'] },
  { key: 'aunt', label: 'Aunt', extras: ['familySide'] },
  { key: 'cousin', label: 'Cousin', extras: ['familySide', 'cousinKind', 'customDetail'] },
  { key: 'nephew', label: 'Nephew', extras: [] },
  { key: 'niece', label: 'Niece', extras: [] },
  { key: 'other_family', label: 'Other family member', extras: ['customDetail'] },
];

const RELATIONS_BY_GROUP = {
  family: FAMILY_RELATIONS,
  friend: [
    { key: 'best_friend', label: 'Best friend', extras: [] },
    { key: 'childhood_friend', label: 'Childhood friend', extras: [] },
    { key: 'school_friend', label: 'School friend', extras: [] },
    { key: 'college_friend', label: 'College friend', extras: [] },
    { key: 'work_friend', label: 'Work friend', extras: [] },
    { key: 'other_friend', label: 'Other', extras: ['customDetail'] },
  ],
  office: [
    { key: 'manager', label: 'Manager', extras: [] },
    { key: 'direct_report', label: 'Direct report', extras: [] },
    { key: 'teammate', label: 'Teammate', extras: [] },
    { key: 'cross_team', label: 'Cross-team colleague', extras: [] },
    { key: 'other_office', label: 'Other', extras: ['customDetail'] },
  ],
  former: [
    { key: 'same_team', label: 'Same team', extras: ['customDetail'] },
    { key: 'same_company', label: 'Same company', extras: ['customDetail'] },
    { key: 'other_former', label: 'Other', extras: ['customDetail'] },
  ],
  professional: [
    { key: 'mentor', label: 'Mentor', extras: [] },
    { key: 'mentee', label: 'Mentee', extras: [] },
    { key: 'vendor', label: 'Vendor / partner', extras: [] },
    { key: 'recruiter', label: 'Recruiter', extras: [] },
    { key: 'other_professional', label: 'Other', extras: ['customDetail'] },
  ],
  client: [
    { key: 'account', label: 'Account contact', extras: ['customDetail'] },
    { key: 'project', label: 'Project contact', extras: ['customDetail'] },
    { key: 'other_client', label: 'Other', extras: ['customDetail'] },
  ],
  neighbor: [
    { key: 'next_door', label: 'Next door', extras: [] },
    { key: 'same_building', label: 'Same building', extras: [] },
    { key: 'same_society', label: 'Same society', extras: [] },
    { key: 'other_neighbor', label: 'Other', extras: ['customDetail'] },
  ],
  classmate: [
    { key: 'school', label: 'School', extras: ['customDetail'] },
    { key: 'college', label: 'College', extras: ['customDetail'] },
    { key: 'other_classmate', label: 'Other', extras: ['customDetail'] },
  ],
  community: [
    { key: 'society', label: 'Society / housing', extras: ['customDetail'] },
    { key: 'religious', label: 'Religious / cultural', extras: ['customDetail'] },
    { key: 'sports', label: 'Sports', extras: ['customDetail'] },
    { key: 'volunteer', label: 'Volunteer', extras: ['customDetail'] },
    { key: 'other_community', label: 'Other', extras: ['customDetail'] },
  ],
  simple: [
    { key: 'known', label: 'Known personally', extras: ['customDetail'] },
    { key: 'other', label: 'Other', extras: ['customDetail'] },
  ],
};

export const FAMILY_SIDE_OPTIONS = [
  { key: 'paternal', label: 'Paternal' },
  { key: 'maternal', label: 'Maternal' },
];

export const COUSIN_KIND_OPTIONS = [
  { key: 'first', label: 'First cousin' },
  { key: 'second', label: 'Second cousin' },
  { key: 'other', label: 'Other' },
];

export const relationshipCategory = (key) =>
  RELATIONSHIP_CATEGORIES.find((item) => item.key === key) || null;

export const relationsForCategory = (categoryKey) => {
  const category = relationshipCategory(categoryKey);
  if (!category) return [];
  return RELATIONS_BY_GROUP[category.group] || [];
};

export const CATEGORY_ICONS = {
  CLOSE_FAMILY: '👨‍👩‍👧',
  FAMILY: '🏠',
  CLOSE_FRIEND: '💛',
  FRIEND: '🤝',
  ACQUAINTANCE: '👋',
  OFFICE_COLLEAGUE: '💼',
  FORMER_COLLEAGUE: '🗂️',
  PROFESSIONAL_CONTACT: '🎯',
  CLIENT: '🧾',
  NEIGHBOR: '🏡',
  CLASSMATE: '🎓',
  COMMUNITY: '🏘️',
  OTHER: '✨',
};

export const RELATION_ICONS = {
  wife: '👩',
  husband: '👨',
  partner: '💑',
  mother: '👩‍🦰',
  father: '👨‍🦱',
  son: '👦',
  daughter: '👧',
  brother: '🧔',
  sister: '👱‍♀️',
  grandmother: '👵',
  grandfather: '👴',
  grandson: '🧒',
  granddaughter: '🧒',
  uncle: '👨‍🦳',
  aunt: '👩‍🦳',
  cousin: '🧑',
  nephew: '👦',
  niece: '👧',
  best_friend: '⭐',
  childhood_friend: '🪁',
  school_friend: '🏫',
  college_friend: '🎓',
  work_friend: '💻',
  other_friend: '✨',
  manager: '👔',
  direct_report: '🙋',
  teammate: '🤜',
  cross_team: '🔗',
  other_office: '✨',
  same_team: '👥',
  same_company: '🏢',
  other_former: '✨',
  mentor: '🧭',
  mentee: '🌱',
  vendor: '📦',
  recruiter: '📋',
  other_professional: '✨',
  account: '📒',
  project: '📌',
  other_client: '✨',
  next_door: '🚪',
  same_building: '🏢',
  same_society: '🌳',
  other_neighbor: '✨',
  school: '🏫',
  college: '🎓',
  other_classmate: '✨',
  society: '🏘️',
  religious: '🕊️',
  sports: '⚽',
  volunteer: '🤲',
  other_community: '✨',
  known: '🙂',
  other: '✨',
  other_family: '✨',
  mother_in_law: '👩',
  father_in_law: '👨',
  brother_in_law: '🧔',
  sister_in_law: '👱‍♀️',
  son_in_law: '👦',
  daughter_in_law: '👧',
};

const FAMILY_ICON_KEYS = [
  'wife', 'husband', 'partner', 'mother', 'father', 'son', 'daughter', 'brother', 'sister',
];

export const categoryIcon = (key) => CATEGORY_ICONS[key] || '✨';

export const relationIcon = (key) => RELATION_ICONS[key] || '👤';

export const splitRelationsForCategory = (categoryKey) => {
  const all = relationsForCategory(categoryKey);
  const category = relationshipCategory(categoryKey);
  if (category?.group !== 'family') {
    return { icons: all, dropdown: [] };
  }
  return {
    icons: all.filter((item) => FAMILY_ICON_KEYS.includes(item.key)),
    dropdown: all.filter((item) => !FAMILY_ICON_KEYS.includes(item.key)),
  };
};

export const relationOption = (categoryKey, relationKey) =>
  relationsForCategory(categoryKey).find((item) => item.key === relationKey) || null;

export const formatRelationshipSummary = (rel) => {
  if (!rel) return '';
  const parts = [rel.explicitRelationLabel || rel.explicitRelationKey, rel.categoryLabel].filter(Boolean);
  if (rel.familySide === 'paternal') parts.push('paternal');
  if (rel.familySide === 'maternal') parts.push('maternal');
  if (rel.cousinKind === 'first') parts.push('first cousin');
  if (rel.cousinKind === 'second') parts.push('second cousin');
  if (rel.customDetail) parts.push(rel.customDetail);
  return parts.join(' · ');
};
